;$(function() {
	$('.simple-tabs__button').click(function() {
		var prevButton = $(this).parents('.card-list').find('.simple-tabs__button_active');
		prevButton.removeClass('simple-tabs__button_active');
		$(this).addClass('simple-tabs__button_active');

		$(this).parents('.card-list').find(prevButton.data('target')).addClass('hidden');
		$(this).parents('.card-list').find($(this).data('target')).removeClass('hidden');
	});
});